import { z } from 'zod';
import { PageTypeEnum } from '../types/pages.js';

export {
  PageTypeEnum,
  PageVersionSchema,
  PageSchema,
  PageDetailSchema,
  GetPagesResponseSchema,
  GetPageVersionsResponseSchema,
  TableauProviderDataSchema,
} from '../types/pages.js';

export type {
  PageType,
  PageVersion,
  Page,
  PageDetail,
  GetPagesResponse,
  GetPageVersionsResponse,
  TableauProviderData,
} from '../types/pages.js';

export const CreatePageSchema = z.object({
  name: z.string().min(1),
  type: PageTypeEnum,
  dataConnector: z.string().nullable().optional(),
  templateId: z.number().int().positive().nullable().optional(),
  isTemplate: z.boolean().optional(),
  /** For third_party pages: iframe URL, provider name, etc. */
  providerData: z.record(z.string(), z.unknown()).optional(),
});
export namespace CreatePage {
  export type Request = z.infer<typeof CreatePageSchema>;
}

export const UpdatePageSchema = z.object({
  name: z.string().min(1).optional(),
  dataConnector: z.string().nullable().optional(),
  isTemplate: z.boolean().optional(),
  providerData: z.record(z.string(), z.unknown()).optional(),
});
export namespace UpdatePage {
  export type Request = z.infer<typeof UpdatePageSchema>;
}

export const CreatePageVersionSchema = z.object({
  /** Full DashboardConfig JSON — validated against DashboardConfigSchema server-side */
  config: z.record(z.string(), z.unknown()),
  description: z.string().optional(),
});
export namespace CreatePageVersion {
  export type Request = z.infer<typeof CreatePageVersionSchema>;
}

export const ProxyWidgetDataSchema = z.object({
  /** FK to the agent record to proxy requests through */
  agentId: z.number().int(),
  /** Path appended to the agent's base URL (e.g. "/api/report") */
  extensionPath: z.string(),
  /** Optional brand identifier — when provided, the proxy resolves brand details and includes them in the agent request context */
  brandIdentifier: z.string().optional(),
});
export namespace ProxyWidgetData {
  export type Request = z.infer<typeof ProxyWidgetDataSchema>;
}

export const GetPagesQuerySchema = z.object({
  type: PageTypeEnum.optional(),
  isTemplate: z
    .enum(['true', 'false'])
    .transform(v => v === 'true')
    .optional(),
});
export namespace GetPages {
  export type Query = z.infer<typeof GetPagesQuerySchema>;
}
